import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminContent = lazy(() => import("@/pages/admin/AdminContent"));

export const Route = createFileRoute("/admin/innehall")({
  component: () => <AdminContent />,
});
